export const UserPictureType = {
  LOAD: 'LOAD',
  UNLOAD: 'UNLOAD',
  WEIGHING_SLIP: 'WEIGHING_SLIP'
}
